import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { baseUrl } from '../comman/config';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { menuAboveTable } from "../comman/selectMenu";

const EventPersonCountEstimation = () => {
    const [loading, setLoading] = useState(false);
    const [eventList, setEventList] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [eventData, setEventData] = useState(null);
    const [sessions, setSessions] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [countData, setCountData] = useState({});
    const [error, setError] = useState(null);
    const [totalCounts, setTotalCounts] = useState({});
    const [noMeals, setNoMeals] = useState(false);
    const navigate = useNavigate();

    // Fetch event list on component mount
    useEffect(() => {
        getEventList();
        getSessionList();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
      
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2); // Get last 2 digits
        const weekday = date.toLocaleDateString('en-GB', { weekday: 'short' }); // e.g., Mon, Tue
      
        return `${day}-${month}-${year}, ${weekday}`;
      };
      

    // Fetch sessions list
    const getSessionList = async () => {
        try {
            const response = await axios.get(`${baseUrl}/comman/list?table=session_master&condition=status=1`);
            const data = response.data.data;
            setSessions(data);
        } catch (error) {
            console.error('Error fetching session list:', error);
            toast.error('Failed to load sessions');
            // setError('Failed to load sessions');
        }
    };

    // Fetch event list
    const getEventList = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${baseUrl}/comman/list?table=event_master&condition=status=1`);
            const data = response.data.data;
            setEventList(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching event list:', error);
            toast.error('Failed to load events');
            // setError('Failed to load events');
            setLoading(false);
        }
    };

    // Handle event selection
    const handleEventChange = async (selectedOption) => {
        setSelectedEvent(selectedOption);
        setCountData({});
        setTotalCounts({});
        setDateRange([]);
        setNoMeals(false);

        if (selectedOption) {
            try {
                setLoading(true);
                // Fetch event details including start and end date
                const response = await axios.get(`${baseUrl}/comman/list?table=event_master&condition=id=${selectedOption.value}`);
                const eventDetails = response.data.data;
                console.log("eventDetails", eventDetails);

                if (eventDetails) {
                    setEventData(eventDetails);

                    // Try to fetch existing data if available
                    // Will also handle generating date range
                    await fetchExistingCountData(selectedOption.value);
                }

                setLoading(false);
            } catch (error) {
                console.error('Error fetching event details:', error);
                toast.error('Failed to load event details');
                // setError('Failed to load event details');
                setLoading(false);
            }
        }
    };

    // Generate date range from start and end date or from meal dates
    const generateDateRange = (startDate, endDate, mealDates = null) => {
        // If we have specific meal dates, use those instead
        console.log("mealDates", mealDates);
        if (mealDates && mealDates.length > 0) {
            const uniqueDates = [...new Set(mealDates.map(item => item.meal_date))];
            console.log("uniqueDates", uniqueDates);
            return uniqueDates.map(dateStr => new Date(dateStr));
        }

        // Otherwise generate all dates in the range
        const dates = [];
        const start = new Date(startDate);
        const end = new Date(endDate);

        let currentDate = new Date(start);
        while (currentDate <= end) {
            dates.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
    };

// const fetchExistingCountData = async (eventId) => {
//     try {
//         const response = await axios.get(`${baseUrl}/event_count/view?event_id=${eventId}`);
//         console.log("Event count response:", response.data);
        
//         if (response.data.status) {
//             const eventDetails = eventData || response.data.event;
            
//             // Use the sessions from the API response if available
//             let  availableSessions = response.data.sessions || [];

//             // Ensure "Breakfast" (id: 3) is the first session
//             availableSessions = availableSessions.sort((a, b) => {
//                 if (a.id === 3) return -1; // Move "Breakfast" to the top
//                 if (b.id === 3) return 1;
//                 return 0;
//             });

//             setSessions(availableSessions);
            
//             // Case 1: We have pre-event count data
//             if (response.data.data && response.data.data.length > 0) {
//                 console.log("Found existing count data");
                
//                 // Generate date range from existing data dates
//                 const uniqueDates = [...new Set(response.data.data.map(item => item.date))];
//                 console.log("uniques dates:",uniqueDates)
//                 const dates = uniqueDates.map(dateStr => new Date(dateStr));
//                 console.log("dates:",dates);
//                 // Format and set the existing data
//                 const existingData = {};
//                 const existingTotals = {};
                
//                 uniqueDates.forEach(dateStr => {
//                     existingData[dateStr] = {};
//                     availableSessions.forEach(session => {
//                         // Initialize all sessions to empty string
//                         existingData[dateStr][session.id] = '';
//                     });
//                 });
                
//                 // Now populate with actual data
//                 response.data.data.forEach(item => {
//                     existingData[item.date][item.session_id] = item.estimated_count;
                    
//                     // Calculate row totals
//                     if (!existingTotals[item.date]) {
//                         existingTotals[item.date] = 0;
//                     }
//                     existingTotals[item.date] += parseInt(item.estimated_count || 0);
//                 });
                
//                 setCountData(existingData);
//                 setTotalCounts(existingTotals);
//                 setDateRange(dates);
//                 return;
//             }
            
//             // Case 2: No pre-event data but we have meal dates in the response
//             else if (response.data.hasMeals && response.data.mealDates && response.data.mealDates.length > 0) {
//                 console.log("Using meal dates from response");
                
//                 const dates = response.data.mealDates.map(item => new Date(item.meal_date));
                
//                 // Initialize countData with empty values for meal dates and sessions
//                 const initialData = {};
//                 dates.forEach(date => {
//                     const dateStr = date.toISOString().split('T')[0];
//                     initialData[dateStr] = {};
//                     availableSessions.forEach(session => {
//                         initialData[dateStr][session.id] = '';
//                     });
//                 });
//                 setCountData(initialData);
//                 setDateRange(dates);
//                 return;
//             }
            
//             // Case 3: No pre-event data, but meals exist - need to fetch dates
//             else if (response.data.hasMeals === true) {
//                 console.log("Meals exist - fetching dates");
                
//                 try {
//                     // Get meal dates from backend
//                     const mealDatesResponse = await axios.get(`${baseUrl}/meals/dates?event_id=${eventId}`);
                    
//                     if (mealDatesResponse.data.status && mealDatesResponse.data.dates && 
//                         mealDatesResponse.data.dates.length > 0) {
                        
//                         // Convert dates to Date objects
//                         const dates = mealDatesResponse.data.dates.map(item => new Date(item.date));
                        
//                         // Initialize countData with empty values
//                         const initialData = {};
//                         dates.forEach(date => {
//                             const dateStr = date.toISOString().split('T')[0];
//                             initialData[dateStr] = {};
//                             availableSessions.forEach(session => {
//                                 initialData[dateStr][session.id] = '';
//                             });
//                         });
                        
//                         setCountData(initialData);
//                         setDateRange(dates);
//                         return;
//                     }
//                 } catch (error) {
//                     console.error('Error fetching meal dates:', error);
//                     // Continue to fallback case
//                 }
//             }
            
//             // Case 4: No meals exist at all
//             else if (response.data.hasMeals === false) {
//                 console.log("No meals exist for this event");
//                 setNoMeals(true);
//                 return;
//             }
            
//             // Case 5: Fallback - use event date range
//             console.log("Falling back to event date range");
//             if (eventDetails && eventDetails.start_date && eventDetails.end_date) {
//                 const dates = generateDateRange(eventDetails.start_date, eventDetails.end_date);
                
//                 // Initialize countData with empty values
//                 const initialData = {};
//                 dates.forEach(date => {
//                     const dateStr = date.toISOString().split('T')[0];
//                     initialData[dateStr] = {};
//                     availableSessions.forEach(session => {
//                         initialData[dateStr][session.id] = '';
//                     });
//                 });
                
//                 setCountData(initialData);
//                 setDateRange(dates);
//                 return;
//             } else {
//                 // No valid date range available
//                 console.error("No valid date range available");
//                 setNoMeals(true);
//             }
//         }
//     } catch (error) {
//         console.error('Error fetching existing count data:', error);
//         setError('Failed to load event data. Please try again.');
//     }
// };
const fetchExistingCountData = async (eventId) => {
    try {
        const response = await axios.get(`${baseUrl}/event_count/view?event_id=${eventId}`);
        console.log("Event count response:", response.data);
        
        if (response.data.status) {
            const eventDetails = eventData || response.data.event;
            
            // Use the sessions from the API response if available
            let availableSessions = response.data.sessions || [];

            // Ensure "Breakfast" (id: 3) is the first session
            availableSessions = availableSessions.sort((a, b) => {
                if (a.id === 3) return -1; // Move "Breakfast" to the top
                if (b.id === 3) return 1;
                return 0;
            });

            setSessions(availableSessions);
            
            // Determine the date range to use
            let dateRange = [];
            
            // Priority 1: Use meal dates if available
            if (response.data.hasMeals && response.data.mealDates && response.data.mealDates.length > 0) {
                console.log("Using meal dates from response");
                dateRange = response.data.mealDates.map(item => item.meal_date);
            }
            // Priority 2: Try to fetch meal dates if meals exist but dates not provided
            else if (response.data.hasMeals === true) {
                console.log("Meals exist - fetching dates");
                try {
                    const mealDatesResponse = await axios.get(`${baseUrl}/meals/dates?event_id=${eventId}`);
                    
                    if (mealDatesResponse.data.status && mealDatesResponse.data.dates && 
                        mealDatesResponse.data.dates.length > 0) {
                        dateRange = mealDatesResponse.data.dates.map(item => item.date);
                    }
                } catch (error) {
                    console.error('Error fetching meal dates:', error);
                    // Continue to fallback
                }
            }
            
            // Priority 3: Use event date range as fallback
            if (dateRange.length === 0 && eventDetails && eventDetails.start_date && eventDetails.end_date) {
                console.log("Falling back to event date range");
                const dates = generateDateRange(eventDetails.start_date, eventDetails.end_date);
                dateRange = dates.map(date => date.toISOString().split('T')[0]);
            }
            
            // If no valid date range found
            if (dateRange.length === 0) {
                console.log("No meals exist for this event or no valid date range");
                setNoMeals(true);
                return;
            }
            
            // Initialize countData with ALL dates in the range
            const initialData = {};
            const initialTotals = {};
            
            dateRange.forEach(dateStr => {
                initialData[dateStr] = {};
                initialTotals[dateStr] = 0;
                availableSessions.forEach(session => {
                    // Initialize all sessions to empty string
                    initialData[dateStr][session.id] = '';
                });
            });
            
            // Now populate with existing data if available
            if (response.data.data && response.data.data.length > 0) {
                console.log("Found existing count data - populating");
                
                response.data.data.forEach(item => {
                    // Only populate if the date exists in our date range
                    if (initialData[item.date]) {
                        initialData[item.date][item.session_id] = item.estimated_count;
                        
                        // Calculate row totals
                        initialTotals[item.date] += parseInt(item.estimated_count || 0);
                    }
                });
            } else {
                console.log("No existing count data - showing empty form");
            }
            
            // Convert date strings back to Date objects for setDateRange
            const dates = dateRange.map(dateStr => new Date(dateStr));
            
            setCountData(initialData);
            setTotalCounts(initialTotals);
            setDateRange(dates);
            
        } else {
            setError('Failed to load event data. Please try again.');
        }
    } catch (error) {
        console.error('Error fetching existing count data:', error);
        setError('Failed to load event data. Please try again.');
    }
};
    const handleRefresh = () => {
        window.location.reload();
    }

    // Handle count input change
    const handleCountChange = (date, sessionId, value) => {
        // Allow only numbers
        const numericValue = value.replace(/[^0-9]/g, '');

        setCountData(prevData => {
            const newData = { ...prevData };
            if (!newData[date]) {
                newData[date] = {};
            }
            newData[date][sessionId] = numericValue;

            // Calculate row total
            let rowTotal = 0;
            sessions.forEach(session => {
                rowTotal += parseInt(newData[date][session.id] || 0);
            });

            // Update total counts
            setTotalCounts(prev => ({
                ...prev,
                [date]: rowTotal
            }));

            return newData;
        });
    };

    // Save all data
    const handleSave = async () => {
        try {
            setLoading(true);

            // Prepare data for API
            const saveData = [];

            Object.entries(countData).forEach(([date, sessionData]) => {
                Object.entries(sessionData).forEach(([sessionId, count]) => {
                    if (count !== '') {
                        saveData.push({
                            event_id: selectedEvent.value,
                            date,
                            session_id: sessionId,
                            estimated_count: count
                        });
                    }
                });
            });

            // Call API to save data
            const response = await axios.post(`${baseUrl}/event_count/save`, {
                event_id: selectedEvent.value,
                count_data: saveData
            });

            if (response.data.status) {
                alert('Estimated person count saved successfully!');
                // If needed, redirect or reload data
            } else {
                toast.error('Failed to save data: ' + response.data.message);
                // setError('Failed to save data: ' + response.data.message);
            }

            setLoading(false);
        } catch (error) {
            console.error('Error saving count data:', error);
            toast.error('Failed to save data');
            // setError('Failed to save data');
            setLoading(false);
        }
    };

    return (
        <div className="p-6">
            {loading && <Loader />}
            <>
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-2xl font-bold">Pre-Event Estimated Person Count</h1>
            </div>
            <div className="flex justify-end">
                <button
                    onClick={handleRefresh}
                    className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                >
                    Refresh
                </button>
            </div>
            </>

            <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">Select Event</label>
                <Select
                    {...menuAboveTable}
                    className="w-64"
                    value={selectedEvent}
                    onChange={handleEventChange}
                    options={eventList.map(event => ({
                        value: event.id,
                        label: event.event_name
                    }))}
                    placeholder="Select Event"
                    isClearable
                />
            </div>

            {error && (
                <div className="mb-4 p-4 bg-red-100 text-red-700 rounded-md">
                    {error}
                </div>
            )}

            {selectedEvent && noMeals && (
                <div className="text-center p-8 bg-gray-50 rounded-md">
                    No dates available for selected time range.
                </div>
            )}

            {selectedEvent && dateRange.length > 0 && (
                <div className="overflow-x-auto">
                    <table className="w-full text-sm text-left border border-gray-300">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="px-6 py-3 border">Date</th>
                                {sessions.map(session => (
                                    <th key={session.id} className="px-6 py-3 border capitalize">
                                        {session.session_name}
                                    </th>
                                ))}
                                {/* <th className="px-6 py-3 border">Total</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {dateRange.map((date) => {
                                const dateStr = date.toISOString().split('T')[0];
                                const dateParts = dateStr.split('-');
                                const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0].substring(2)}`;

                                return (
                                    <tr key={dateStr} className="border-b hover:bg-gray-50">
                                        <td className="px-6 py-4 border font-medium">
                                            {formatDate(dateStr)}
                                        </td>
                                        {sessions.map(session => (
                                            <td key={`${dateStr}-${session.id}`} className="px-6 py-3 border">
                                                <input
                                                    type="text"
                                                    value={countData[dateStr]?.[session.id] || ''}
                                                    onChange={(e) => handleCountChange(dateStr, session.id, e.target.value)}
                                                    className="w-full border border-gray-300 p-2 rounded-md"
                                                />
                                            </td>
                                        ))}
                                        {/* <td className="px-6 py-4 border font-medium">
                                            {totalCounts[dateStr] || 0}
                                        </td> */}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={handleSave}
                            className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                        >
                            Save
                        </button>
                    </div>
                </div>
            )}

            {selectedEvent && dateRange.length === 0 && !noMeals && !loading && (
                <div className="text-center p-8 bg-gray-50 rounded-md">
                    Loading event dates...
                </div>
            )}
        </div>
    );
};

export default EventPersonCountEstimation;